import { client } from './sanity'

type UploadedAsset = {
  _id: string
  url?: string
}

// Uploads a hero image asset to Sanity and returns its id + URL.
// NOTE: This runs in the browser using the configured token; keep tokens dev-only.
export const uploadHeroImage = async (
  file: File
): Promise<{ assetId: string; url?: string }> => {
  const asset = (await client.assets.upload('image', file, {
    filename: file.name,
  })) as UploadedAsset

  return {
    assetId: asset._id,
    url: asset.url,
  }
}
